<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiArrowDown } from "@mdi/js"

export default {
  name: "ArrowDownIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiArrowDown,
    }
  }
}
</script>
